PP.PlayerCharacterController = class PlayerCharacterController extends PP.SyncedCharacterController {
    constructor() {
        super();
    }
};